import { render, staticRenderFns } from "./serbestfaturaexcel.vue?vue&type=template&id=6bbe87cc&"
import script from "./serbestfaturaexcel.vue?vue&type=script&lang=js&"
export * from "./serbestfaturaexcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports